import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const phanTichMenu: NavMenu = {
  title: 'Phân tích',
  items: [
    {
      title: 'Phân tích báo cáo tài chính',
      items: [
        {
          title: 'Báo cáo kết quả hoạt động sản xuất kinh doanh theo đối tượng',
          icon: <AritoIcon icon={231} />,
          href: '/phan-tich/phan-tich-bao-cao-tai-chinh/bao-cao-ket-qua-hoat-dong-san-xuat-kinh-doanh-theo-doi-tuong'
        }
      ]
    }
  ]
};
